import { translate } from "../locales/src/translate";

export const mapRequiredStringValue = (value: string | undefined): string => {
  if (!value) {
    throw new Error(translate("VerplichtVeldIsNietIngevuldTijdensVerzenden"));
  }
  return value;
};

export const mapOptionalStringValue = (value: string | undefined): string | null => {
  return value || null;
};
